import React from 'react'
import { uploadedFileUrl } from '../../../../utils/constants/links'
import { Box } from '@mui/material'

const ViewEmiScreenshot = ({attachmentFileName}) => {
  return (
    <Box sx={{ height: '70vh', width: '100%' }}>
          {!attachmentFileName ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '18px',
                color: 'gray',
                fontWeight: 500,
              }}
            >
              No Attachment Available
            </Box>
          ) : attachmentFileName?.toLowerCase().endsWith('.pdf') ? (
            <iframe
              src={`${uploadedFileUrl}/${attachmentFileName}`}
              width="100%"
              height="100%"
              title="Uploaded PDF"
              style={{ border: 'none', borderRadius: 4 }}
            ></iframe>
          ) : (
            <img
              src={`${uploadedFileUrl}/${attachmentFileName}`}
              alt="Uploaded File"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                borderRadius: 4,
                border: '1px solid #ccc',
              }}
            />
          )}
        </Box>
  )
}

export default ViewEmiScreenshot
